import { Tooltip } from "antd";
import * as React from 'react';

export class CustomFields {
	public static getPageDisplayOnValue = (displayValue: string, picklistItems: PickListItemResponseDTO[]) => {
		const displayOn = picklistItems.find((pItem: PickListItemResponseDTO) => pItem.code === displayValue) as PickListItemResponseDTO;
		return displayOn ? displayOn.id! : 0;
	}

	public static renderCustomFieldColumn = (customFields: CustomFieldDTO[], cellRender: any) => {
		const columns = customFields.map(field => {
			return {
				Header: ((data: any, column: any) => 
				<Tooltip title={field.name!}>
					{field.name!}
				</Tooltip>),
				id: field.name,
				filterable: true,
				accessor: (row: any) => {
					const foundValue = row.customFieldValues !== undefined ? row.customFieldValues.find((cf: CustomFieldValueDTO) => cf.name === field.name) : false;
					if (foundValue) {
						return foundValue.value;
					}
					return '';
				},
				Cell: cellRender
			};
		});
		return columns;
	}

	public static getCustomFieldValueToDisplay = (customFieldValues: CustomFieldValueDTO[], customFieldId: number) => {
		const foundField = customFieldValues.find(cf => cf.fieldId === customFieldId);
		return foundField ? foundField.value : '-';
	}

	public static changeCustomFieldLabelValue = (row: any) => {
		const labelValue = row.value !== undefined ? row.value.toString() : '';
		if (labelValue[0] === ',') {
			const newLabelValue = labelValue.split(',').join(', ').slice(1);
			return newLabelValue;
		}
		return labelValue;
	}

}